import { render } from "./ListeFiliereNiveauMatiere..vue?vue&type=template&id=c9a05204&ts=true"
import script from "./ListeFiliereNiveauMatiere..vue?vue&type=script&lang=ts"
export * from "./ListeFiliereNiveauMatiere..vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__